import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Search, Bell, Activity } from "lucide-react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

const baseBtn =
  "relative flex items-center justify-center rounded-2xl border border-white/10 text-bloq-muted transition-colors hover:text-white hover:bg-white/5";

export function SearchButton({ className, size = "h-10 w-10" }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate("/app/search")}
      className={cn(baseBtn, size, className)}
      data-testid="open-search-btn"
      title="Search"
    >
      <Search className="h-5 w-5" />
    </button>
  );
}

export function NotifBell({ className, size = "h-10 w-10" }) {
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ["notifications"],
    queryFn: api.notifications,
    refetchInterval: 60000,
  });
  const unread = data?.unread || 0;
  return (
    <button
      onClick={() => navigate("/app/notifications")}
      className={cn(baseBtn, size, className)}
      data-testid="open-notifications-btn"
      title="Notifications"
    >
      <Bell className="h-5 w-5" />
      {unread > 0 && (
        <span
          className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-bloq-mint px-1 text-[10px] font-bold text-bloq-bg"
          data-testid="notif-unread-badge"
        >
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </button>
  );
}

// Activity feed bell (v1.2.2) — replies to you + reactions on your messages.
export function ActivityBell({ className, size = "h-10 w-10" }) {
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ["activity"],
    queryFn: api.activity,
    refetchInterval: 60000,
  });
  const unread = data?.unread || 0;
  return (
    <button
      onClick={() => navigate("/app/activity")}
      className={cn(baseBtn, size, className)}
      data-testid="open-activity-btn"
      title="Activity"
    >
      <Activity className="h-5 w-5" />
      {unread > 0 && (
        <span
          className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-bloq-mint px-1 text-[10px] font-bold text-bloq-bg"
          data-testid="activity-unread-badge"
        >
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </button>
  );
}
